import React from "react";

const Onboarding2 = () => {
    return (
        <div>Hello</div>
    );
}

export default Onboarding2;